import checkedGreenIcon from '@assets/icons/rockpool/FooterCard/checkedGreenIcon.svg'
import defaultCollection from '@assets/icons/rockpool/FooterCard/defaultCollection.svg'
import Image from 'next/image'
import { useState } from 'react'
import styled from 'styled-components'
import { NetworksName } from '../../../../config'
import { imgLH3 } from '../../../../services/UtilService'
import { Collection } from '../../../../types/CollectionTypes'
import Icon from '../../../shared/Icon'

interface NFTCollectionFooterCardProps {
  collection: Collection
}
export function NFTCollectionFooterCard({ collection }: NFTCollectionFooterCardProps) {
  const [imageCollection, setImageCollection] = useState(collection.image_url)
  function handleError() {
    setImageCollection('')
  }
  return (
    <Container>
      <Header>
        {imageCollection ? (
          <ImageCollection
            src={imgLH3(imageCollection, 40, 40)}
            alt={collection.collectionName || 'collection image'}
            onError={() => handleError()}
          />
        ) : (
          <ImageCollection src={defaultCollection.src} alt='default image collection' />
        )}
        <h1>{collection.collectionName}</h1>
        <div>
          {collection.verified && (
            <VerifiedTag>
              <Image src={checkedGreenIcon.src} alt='icon' width={13} height={13} />
              <p>verified</p>
            </VerifiedTag>
          )}
          {!collection.verified && <div />}
          <Icon name={NetworksName.ethereum} size={24} />
        </div>
      </Header>
      <Description>{collection.description}</Description>
    </Container>
  )
}

export const { Container, Header, Description, ImageCollection, VerifiedTag } = {
  Container: styled.div`
    width: 100%;
    padding: 16px;
    display: grid;
  `,
  Header: styled.div`
    display: grid;
    align-items: center;
    column-gap: 8px;
    grid-template-columns: 40px 1fr 104px;
    h1 {
      max-width: 130px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-weight: 300;
      font-size: 16px;
      line-height: 100%;

      color: ${props => props.theme.colors.black};
    }
    > div {
      display: grid;
      grid-template-columns: 76px 24px;
      justify-content: flex-end;
      gap: 4px;

      img {
        width: 24px !important;
        height: 24px !important;
      }
    }
  `,
  VerifiedTag: styled.div`
    display: grid;
    grid-template-columns: 14px 1fr;
    align-items: center;
    height: 24px;
    padding: 0 6px;

    gap: 6px;

    border-radius: 8px;

    background: ${props => props.theme.colors.white};
    > p {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 133%;

      color: ${props => props.theme.colors.black};
    }
  `,
  Description: styled.p`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 133%;

    color: ${props => props.theme.colors.black};

    overflow: hidden;
    text-overflow: ellipsis;

    max-width: 282px;
    max-height: 57px;
  `,
  ImageCollection: styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
  `
}
